import Div from "@jumbo/shared/Div/Div";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import SimCardDownloadOutlinedIcon from "@mui/icons-material/SimCardDownloadOutlined";
import Card from "@mui/material/Card";
import Chip from "@mui/material/Chip";
import IconButton from "@mui/material/IconButton";
import ErrorPreview from "app/pages/Docgen/components/common/error-preview/ModalPreview";
import {useEffect, useState} from "react";
import {post} from "../../../common/network";


const ImportedMatterCard = ({id, name, date, duration, total, imported, addedBy, fullName, status, errorMessage}) => {
    const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);
    const [isErrorMessage, setIsErrorMessage] = useState();
    const [selectedId, setSelectedId] = useState(null);

    // HANDLE DOWNLOAD FUNCTION
    const handleDownload = type => downloadMatter(type);
    // HANDLE DOWNLOAD FUNCTION

    //call download api
    const downloadMatter = async (type) => {
        try {
            const response = await post(`docgen/import/matters/download`, {
                form_id: id,
                type: type
            }, null, false);

            // Get the current timestamp
            const timestamp = new Date().getTime();

            const contentDispositionHeader =
                response.headers["Content-Disposition"];
            const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            const matches = filenameRegex.exec(contentDispositionHeader);
            const suggestedFilename =
                matches && matches[1]
                    ? matches[1].replace(/['"]/g, "")
                    : `matters-${timestamp}.csv`;
            // Create a Blob from the response content
            const blob = new Blob([response.data], {type: "text/csv"});

            // Create a URL for the blob response
            const url = URL.createObjectURL(blob);

            // Create a hidden anchor element
            const anchor = document.createElement("a");
            anchor.style.display = "none";
            anchor.href = url;
            anchor.download = suggestedFilename; // Set the desired file name

            // Append the anchor to the document body
            document.body.appendChild(anchor);

            // Simulate a click on the anchor to trigger the download
            anchor.click();

            // Remove the anchor from the document body
            document.body.removeChild(anchor);
        } catch (error) {
        }
    };
    // Handle some user interaction or event to set the selectedId
    const handleItemClick = (itemId) => {
        setSelectedId(itemId); // Set the selectedId when the user interacts with an item
    };

    const handleViewErrorClick = () => {
        setIsErrorModalOpen(true);
    };

    useEffect(() => {
        setIsErrorMessage(errorMessage);
    }, [errorMessage]);

    return (
        <Card sx={{boxShadow: "none", p: "10px", mb: "15px"}}>
            <div className="import-matter-card">
                <div className="icon-area">
                    <div className="file-icon" onClick={() => {
                        handleDownload("input");
                    }} style={{cursor: "pointer"}}>
                        <FileDownloadOutlinedIcon sx={{fontSize: "50px", color: "#8B8B8B"}}/>
                    </div>
                    <div className="title">Import</div>
                </div>
                <div className="details-area">
                    <small className="imp_id">Import ID: {id}</small>
                    <h6 className="matter-title">{name}</h6>
                    <div className="grid-wise-details">
                        <div className="grid-item">
                            <div className="grid-column">
                                <CalendarMonthOutlinedIcon
                                    sx={{fontSize: "18px", mr: "5px", mb: "4px"}}
                                />
                                {date}
                            </div>
                            <div className="grid-column">Duration: {duration}</div>
                        </div>
                        <div className="grid-item">
                            <div className="grid-column">
                                <Chip
                                    sx={{
                                        backgroundColor: "#D9D9D9",
                                        p: "0 10px",
                                        borderColor: "#D9D9D9"
                                    }}
                                    label={total}
                                    variant="outlined"
                                />
                            </div>
                            <div className="grid-column">
                                <Chip
                                    sx={{
                                        backgroundColor: "#17B2B6",
                                        p: "0 10px",
                                        color: "#FFF",
                                        borderColor: "#17B2B6"
                                    }}
                                    label={`Imported: ${imported}`}
                                    variant="outlined"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="action-area">
                    <Div
                        sx={{
                            color: "#8B8B8B",
                            mb: "10px",
                            "@media (min-width: 565px)": {
                                mb: "25px"
                            }
                        }}
                    >
                        <small>Added by: {addedBy}</small>
                        <IconButton
                            sx={{p: 0, ml: 1}}
                            className="download-icon-btn"
                            onClick={() => {
                                handleDownload("output");
                            }}
                        >
                            <SimCardDownloadOutlinedIcon/>
                        </IconButton>
                    </Div>
                    <h6>{fullName}</h6>
                    {total > imported && status === "Completed" ? (
                        <Chip
                            sx={{
                                backgroundColor: "red",
                                mr: "10px",
                                p: "0 10px",
                                color: "#FFF",
                                borderColor: "red",
                                mt: "10px"
                            }}
                            label="View Error"
                            variant="outlined"
                            onClick={() => {
                                handleItemClick(id);
                                handleViewErrorClick();
                            }}
                        />
                    ) : null}
                    <Chip
                        sx={{
                            backgroundColor:
                                status === "Error"
                                    ? "red"
                                    : status === "Completed"
                                        ? "green"
                                        : "#17B2B6",
                            p: "0 10px",
                            color: "#FFF",
                            borderColor:
                                status === "Error"
                                    ? "red"
                                    : status === "Completed"
                                        ? "green"
                                        : "#17B2B6",
                            mt: "10px"
                        }}
                        label={status}
                        variant="outlined"
                    />
                </div>
            </div>
            {selectedId && (
                <ErrorPreview
                    isModalOpen={isErrorModalOpen}
                    handleModalClose={() => setIsErrorModalOpen(false)}
                    errorMessage={isErrorMessage}
                />
            )}
        </Card>
    );
};

export default ImportedMatterCard;